import { telegramAuthClientPlugin } from '@coas/better-auth-telegram-plugin/client';
import { emailOTPClient, inferAdditionalFields, phoneNumberClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { toast } from 'sonner';
import { env } from '~/env';

export const authClient = createAuthClient({
    baseURL: env.NEXT_PUBLIC_SERVER_URL,
    plugins: [
        telegramAuthClientPlugin(),
        emailOTPClient(),
        phoneNumberClient(),
        inferAdditionalFields({
            user: {
                role: { type: 'string' },
            },
        }),
    ],
    fetchOptions: {
        credentials: 'include',
        onError: async context => {
            const { response } = context;
            if (response.status !== 429) return;

            const ra = response.headers.get('x-retry-after') ?? response.headers.get('X-Retry-After');

            const seconds = ra ? Math.ceil(Number(ra)) : null;

            if (seconds) {
                const plural = (n: number) =>
                    n % 10 === 1 && n % 100 !== 11
                        ? 'секунду'
                        : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
                          ? 'секунды'
                          : 'секунд';

                toast.warning(`Можно отправить сообщение повторно через ${seconds} ${plural(seconds)}`);
            } else {
                toast.warning('Слишком много попыток, попробуйте позже');
            }
        },
    },
});

export const useSessionAdmin = () => {
    const { data, isPending, error } = authClient.useSession();
    const isAdmin = data?.user.role === 'ADMIN';
    return { isPending, isAdmin, error };
};

export const { useSession } = authClient;
